import state from './state.js'
import { throttle } from '../../lib/utils/general.js'

/**
 * State observer
 * updates cartLines based on responses
 */
state.addObserver(async (name) => {
  switch (name) {
    case 'responses':
      state.syncOrderLines()
      break
    case 'orderLines':
      const cart = await fetch('/cart.js', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }).then(res => res.json())
      state.cart = cart
      break
  }
})
